import { combineRefs } from '@helpers/combineRefs';
import { CarouselDirection } from '@hooks/useCarousel';
import * as React from 'react';
import { useSwipeable } from 'react-swipeable';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './SimpleTrack.styles';
const SimpleTrack = ({ children, initCarousel = true, mobileOnly = false, ...otherProps }) => {
    const carousel = useCarouselContext();
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            carousel.goToNext(false);
        },
        onSwipedRight: () => {
            carousel.goToPrev(false);
        },
    });
    return (React.createElement(S.Container, { ...otherProps, ...swipeHandlers, ref: combineRefs(carousel.refContainer, swipeHandlers.ref), "data-alignment": carousel.alignment, "data-init": carousel.offsets.length !== 0, "data-mobile-only": mobileOnly, "data-vertical": carousel.direction === CarouselDirection.Vertical },
        React.createElement(S.Track, { ref: carousel.refTrack, style: {
                transform: initCarousel
                    ? carousel.direction === CarouselDirection.Horizontal
                        ? `translateX(${carousel.offset * -1}px)`
                        : `translateY(${carousel.offset * -1}px)`
                    : undefined,
            } }, children)));
};
export default SimpleTrack;
